import { tooltips } from "../../locales/en";

const smsTemplateTooltipData = [
  ["editUrl", "tooltip-edit", "edit"],
  ["comment", "tooltip-comment", "sendTestSms"],
  ["toggleVideo", "tooltip-reset", "reset"],
  ["onDelete", "tooltip-delete", "delete"]
];

const allInvoiceTooltipData = [
  ["quote", "tooltip-quote", "quote"],
  ["fnBtn", "tooltip-fnBtn", "fundingNotice"]
];

const invoiceActionsTooltipData = [
  ["quote", "tooltip-quote", "quote"],
  ["setting", "tooltip-funding", "generateFunding"],
  ["download", "tooltip-invoice", "downloadInvoice"],
  ["upload", "tooltip-upload", "uploadInvoiceCopy"],
  ["viewUser", "tooltip-viewUser", "invoiceCopy"],
  ["message", "tooltip-message", "submitInvoice"],
  ["fnBtn", "tooltip-fnBtn", "fundingNotice"],
  ["popDownload", "tooltip-pop-download", "popdoc"]
];

const promoCodeTemplateTooltipData = [
  ["editUrl", "tooltip-edit", "edit"],
  ["reSend", "tooltip-resend", "referralEmail"],
  ["reStore", "tooltip-track", "track"],
  ["onDelete", "tooltip-delete", "delete"]
];

const bannerTemplateTooltipData = [
  ["editUrl", "tooltip-edit", "edit"],
  ["onDelete", "tooltip-delete", "delete"]
];

const editReferaalTooltipData = [
  ["buttonUrl", "tooltip-sales-edit", "edit"],
  ["onDelete", "tooltip-sales-delete", "delete"]
];

const ownerInfoTooltipData = [
  ["sendMail", "tooltip-sendmail", "sendEmail"],
  ["upload", "tooltip-upload", "upload"]
];

const ownerDetailsTooltipData = [["sendSms", "tooltip-sendSms", "sendSms"]];

const headerUserSalesLeadDetailsTooltipData = [
  ["buttonUrl", "tooltip-sales-edit", "edit"],
  ["onDelete", "tooltip-sales-delete", "delete"]
];

const manualUploadTooltipData = [["add", "tooltip-add", "add"]];

const roleManagementTooltipData = [
  ["editUrl", "tooltip-edit", "edit"],
  ["activateUser", "tooltip-activate", "activate"],
  ["deactivateUser", "tooltip-deactivate", "deactivate"]
];

const accSoftwareTooltipData = [
  ["editUrl", "tooltip-edit", "edit"],
  ["activateUser", "tooltip-activate", "activate"],
  ["deactivateUser", "tooltip-deactivate", "deactivate"]
];

const pricingPlanTooltipData = [
  ["editUrl", "tooltip-edit", "edit"],
  ["arChive", "tooltip-archive", "archive"],
  ["arChived", "tooltip-archived", "archived"],
  ["deFault", "tooltip-default", "default"],
  ["setAsDefault", "tooltip-setAsDefault", "setasDefault"],
  ["onDelete", "tooltip-delete", "delete"]
];

const variablePricingTooltipData = [
  ["editUrl", "tooltip-edit", "edit"],
  ["arChive", "tooltip-archive", "archive"],
  ["arChived", "tooltip-archived", "archived"],
  ["setAsDefault", "tooltip-setAsDefault", "setasDefault"],
  ["deFault", "tooltip-default", "default"],
  ["onDelete", "tooltip-delete", "delete"]
];

const userAccessTooltipData = [
  ["buttonUrl", "tooltip-edit", "edit"],
  ["onDelete", "tooltip-delete", "delete"]
];

const generatedKpiTooltipData = [["download", "tooltip-download", "download"]];

const monthlyCommRepoTooltipData = [
  ["email", "tooltip-email", "sendEmail"],
  ["editBtn", "tooltip-editbtn", "edit"],
  ["calender", "tooltip-calender", "dateupdate"]
];

const salesLeadTooltipData = [
  ["editUrl", "tooltip-edit", "edit"],
  ["arChive", "tooltip-archive", "archive"],
  ["reStore", "tooltip-restore", "restore"],
  ["onDelete", "tooltip-delete", "delete"]
];

const checklistTooltipData = [
  ["upload", "tooltip-upload", "uploadFile"],
  ["onDelete", "tooltip-delete", "delete"]
];

const deactivateTooltipData = [
  ["activateUser", "tooltip-activate", "activate"],
  ["onDelete", "tooltip-delete", "delete"]
];

const deleteTooltipData = [
  ["reStore", "tooltip-restore", "restore"],
  ["onDelete", "tooltip-delete", "delete"]
];

const userManagementTooltipData = [
  ["loginUser", "tooltip-login", "loginAs"],
  ["viewUser", "tooltip-view", "view"],
  ["editUrl", "tooltip-edit", "edit"],
  ["changePassword", "tooltip-change-password", "changePassword"],
  ["deactivateUser", "tooltip-deactivate", "deactivate"],
  ["reSend", "tooltip-resend", "resend"],
  ["onDelete", "tooltip-delete", "delete"]
];

const getTooltipsConfig = (tooltipData, tooltipPosition = "top") => {
  return Object.fromEntries(
    tooltipData.map(([key, id, contentKey]) => [
      key,
      {
        id,
        content: tooltips[contentKey],
        place: tooltipPosition
      }
    ])
  );
};

export const SMS_TEMPLATE_TOOLTIP_CONFIG = getTooltipsConfig(
  smsTemplateTooltipData,
  "top"
);
export const ALL_INVOICES_TOOLTIP_CONFIG = getTooltipsConfig(
  allInvoiceTooltipData,
  "top"
);

export const PROMO_CODE_TEMPLATE_TOOLTIP_CONFIG = getTooltipsConfig(
  promoCodeTemplateTooltipData,
  "top"
);

export const BANNER_TEMPLATE_TOOLTIP_CONFIG = getTooltipsConfig(
  bannerTemplateTooltipData,
  "top"
);

export const EDIT_REFERRAL_TOOLTIP_CONFIG = getTooltipsConfig(
  editReferaalTooltipData,
  "top"
);

export const OWNER_INFO_TOOLTIP_CONFIG = getTooltipsConfig(
  ownerInfoTooltipData,
  "top"
);

export const OWNER_DETAILS_TOOLTIP_CONFIG = getTooltipsConfig(
  ownerDetailsTooltipData,
  "top"
);

export const HEADER_USER_SALES_LEAD_DETAILS_TOOLTIP_CONFIG = getTooltipsConfig(
  headerUserSalesLeadDetailsTooltipData,
  "top"
);

export const MANUAL_UPLOAD_TOOLTIP_CONFIG = getTooltipsConfig(
  manualUploadTooltipData,
  "top"
);

export const ROLE_MANAGEMENT_TOOLTIP_CONFIG = getTooltipsConfig(
  roleManagementTooltipData,
  "top"
);

export const ACC_SOFTWARE_TOOLTIP_CONFIG = getTooltipsConfig(
  accSoftwareTooltipData,
  "top"
);

export const PRICING_PLAN_TOOLTIP_CONFIG = getTooltipsConfig(
  pricingPlanTooltipData,
  "top"
);

export const VARIABLE_PRICING_TOOLTIP_CONFIG = getTooltipsConfig(
  variablePricingTooltipData,
  "top"
);

export const USER_ACCESS_TOOLTIP_CONFIG = getTooltipsConfig(
  userAccessTooltipData,
  "top"
);
export const ALL_INVOICE_TOOLTIP_CONFIG = getTooltipsConfig(
  allInvoiceTooltipData,
  "top"
);

export const GENERATED_KPI_TOOLTIP_CONFIG = getTooltipsConfig(
  generatedKpiTooltipData,
  "top"
);

export const MONTHLY_COMM_REPO_TOOLTIP_CONFIG = getTooltipsConfig(
  monthlyCommRepoTooltipData,
  "top"
);

export const SALES_LEAD_TOOLTIP_CONFIG = getTooltipsConfig(
  salesLeadTooltipData,
  "top"
);

export const CHECKLIST_TOOLTIP_CONFIG = getTooltipsConfig(
  checklistTooltipData,
  "top"
);

export const DEACTIVATE_TOOLTIP_CONFIG = getTooltipsConfig(
  deactivateTooltipData,
  "top"
);

export const DELETE_TOOLTIP_CONFIG = getTooltipsConfig(
  deleteTooltipData,
  "top"
);

export const USER_MANAGEMENT_TOOLTIP_CONFIG = getTooltipsConfig(
  userManagementTooltipData,
  "top"
);

export const INVOICE_ACTIONS_TOOLTIP_CONFIG = getTooltipsConfig(
  invoiceActionsTooltipData,
  "top"
);
